import { ReactNode } from 'react';

export enum Variant {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  INFO = 'INFO',
}

export enum Position {
  TOP_RIGHT = 'TOP_RIGHT',
  TOP_CENTER = 'TOP_CENTER',
  TOP_LEFT = 'TOP_LEFT',
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  BOTTOM_CENTER = 'BOTTOM_CENTER',
  BOTTOM_LEFT = 'BOTTOM_LEFT',
}

export type VariantTypes = keyof typeof Variant;
export type PositionTypes = keyof typeof Position;
export type TransitionState =
  | 'entering'
  | 'entered'
  | 'exiting'
  | 'exited'
  | 'unmounted';

export type Callback = (id: string) => void;

export type AddNotification = (
  content: TNotificationContent,
  options: TNotificationOptions,
  cb?: (id: string) => void,
) => void;
export type SuccessMessage = (message: string) => void;
export type ErrorMessage = (message: string) => void;
export type RemoveNotification = (
  id: string,
  cb?: (id: string) => void,
) => void;

export interface INotificaitonCenterContext {
  addNotification: AddNotification;
  showSuccess: SuccessMessage;
  showError: ErrorMessage;
  removeNotification: RemoveNotification;
  notificationList: readonly TNotificationType[];
}

export interface INotificationProps {
  variant: VariantTypes;
  autoDismiss?: boolean | number;
  autoDismissTimeout: number;
  content: TNotificationContent;
  children: ReactNode;
  isRunning: boolean;
  onDismiss: () => void;
  onMouseEnter: () => void;
  onMouseExit: () => void;
  position: PositionTypes;
  transitionDuration: number;
  transitionState: TransitionState;
}

export interface INotificationContainerProps {
  children: ReactNode;
  hasNotification: boolean;
  className?: string;
  position: PositionTypes;
}

export type TNotificationCenterProviderProps = {
  autoDismissTimeout?: number;
  autoDismiss?: boolean;
  children: ReactNode;
  position: PositionTypes;
  portalTargetSelector?: string;
  transitionDuration?: number;
};

export type TNotificationCenterConsumerProps = {
  children: (context: INotificaitonCenterContext) => ReactNode;
};

export type TNotificationCenterProviderState = {
  notifications: INotificationsType;
};

export type TNotificationContent = {
  title?: ReactNode;
  description: ReactNode;
};

export type TNotificationOptions = {
  variant?: VariantTypes;
  autoDismiss?: boolean;
  id?: string;
  onDismiss?: (id: string) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
};

export type TNotificationType = TNotificationOptions & {
  variant?: VariantTypes;
  content: TNotificationContent;
  id: string;
};
export type INotificationsType = Array<TNotificationType>;
